document.addEventListener("DOMContentLoaded", () => {
  const canvas = document.getElementById("snowCanvas");
  const ctx = canvas.getContext("2d");

  // Set canvas size
  canvas.width = window.innerWidth;
  canvas.height = window.innerHeight;

  // Snowflake properties
  const numFlakes = 120;
  const flakes = [];

  // Create snowflake objects
  for (let i = 0; i < numFlakes; i++) {
    flakes.push({
      x: Math.random() * canvas.width, // Random X position
      y: Math.random() * canvas.height, // Random Y position
      radius: Math.random() * 2 + 1, // Random size
      speedX: Math.random() * 0.2 - 0.1, // Even slower horizontal speed
      speedY: Math.random() * 1 + 0.2, // Even slower vertical speed
    });
  }

  // Draw snowflakes
  function drawFlakes() {
    ctx.clearRect(0, 0, canvas.width, canvas.height); // Clear canvas
    ctx.fillStyle = "white"; // Snowflake color
    ctx.beginPath();
    flakes.forEach((flake) => {
      ctx.moveTo(flake.x, flake.y);
      ctx.arc(flake.x, flake.y, flake.radius, 0, Math.PI * 2);
    });
    ctx.fill();
  }

  // Update snowflake positions
  function updateFlakes() {
    flakes.forEach((flake) => {
      flake.x += flake.speedX;
      flake.y += flake.speedY;

      // Reset snowflake when it goes off-screen
      if (flake.x > canvas.width || flake.x < 0 || flake.y > canvas.height) {
        flake.x = Math.random() * canvas.width;
        flake.y = -10;
      }
    });
  }

  // Animation loop
  function animateSnow() {
    drawFlakes();
    updateFlakes();
    requestAnimationFrame(animateSnow);
  }

  animateSnow();

  // Adjust canvas size on window resize
  window.addEventListener("resize", () => {
    canvas.width = window.innerWidth;
    canvas.height = window.innerHeight;
  });
});
